import styled from 'styled-components';
import { Card } from 'ui-toolkit';

export const OtherCostsStyled = styled(Card)<{}>`
  counter-reset: ordered-items-letters 4;

  .ordered-items__index:before {
    counter-increment: ordered-items-letters;
    content: counter(ordered-items-letters, upper-alpha) '.';
  }
`;
